import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface MessageSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedMessageType: string;
  onMessageTypeChange: (type: string) => void;
  messageStats: Record<string, number>;
}

export const MessageSearch = ({
  searchQuery,
  onSearchChange,
  selectedMessageType,
  onMessageTypeChange,
  messageStats,
}: MessageSearchProps) => {
  const clearSearch = () => {
    onSearchChange('');
  };

  const messageTypes = [
    { value: 'all', label: 'All Messages' },
    ...Object.keys(messageStats).map((type) => ({
      value: type,
      label: `${type.toUpperCase()} (${messageStats[type]})`,
    })),
  ];

  return (
    <div className="px-5 py-3 border-b border-gray-100 bg-gray-50 space-y-3">
      {/* Search Input */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" />
        </div>
        <input
          type="text"
          placeholder="Search messages, phone numbers, or content..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
        />
        {searchQuery && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
            <button
              type="button"
              onClick={clearSearch}
              className="text-gray-400 hover:text-gray-600 focus:outline-none"
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          </div>
        )}
      </div>

      {/* Message Type Filter */}
      {messageTypes.length > 1 && (
        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-gray-700 whitespace-nowrap">
            Filter by:
          </span>
          <select
            value={selectedMessageType}
            onChange={(e) => onMessageTypeChange(e.target.value)}
            className="text-xs border border-gray-300 rounded-md px-2 py-1 bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          >
            {messageTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};
